import { render, staticRenderFns } from "./projectcard.vue?vue&type=template&id=7b0aa059&"
import script from "./projectcard.vue?vue&type=script&lang=js&"
export * from "./projectcard.vue?vue&type=script&lang=js&"
import style0 from "./projectcard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports